/* eslint-disable react/react-in-jsx-scope */
import { Route, Routes } from "react-router";
import Dashboard from "./components/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import Index from './components/index';
import Login from './components/login';
import Register from './components/register';
import UserList from './pages/users/UsersList';
import UserDetail from './pages/users/UserDetail';
import PosLayout from  "./components/PosLayout";
import ProductsLayout from  "./components/ProductsLayout";
import Products from "./pages/products";
import CheckOut from './pages/checkout';
import ProductsList from './pages/products/ProductsList';
import ProductDetail from './pages/products/ProductDetail';
import Invoices from './pages/invoices/invoices';
import Stock from './pages/products/stock';
import StockTrans from './pages/products/stockTrans';
import UpdateUser from './api/UpdateUser';
import Test from "./pages/test";
import CartsCustomer from './pages/cartsCustomer';
import Reports from './pages/reports/reports';
import ScanPaid from './pages/reports/scanpaid';
import Income from './pages/reports/income';
import ReserveFunds from './pages/reserveFunds/reserveFunds';
import CheckoutForm from './pages/shipping/checkoutForm';
import Shop from './pages/shipping/shop';

import './App.css';


function App() {
  return (
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/cuscart" element={<CartsCustomer />} />

        <Route element={<PrivateRoute />} >
          <Route  path="/pos" element={<PosLayout />} >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="checkout" element={<CheckOut />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="/pos/products" element={<ProductsLayout />} >
              <Route index element={<Products />} />
              <Route path=":id" element={<Products />} />
            </Route>
          </Route>
          <Route path="users" element={<PosLayout />} >
            <Route index element={<UserList />} />
            <Route path=":userid" element={<UserDetail />} />
          </Route>

          <Route path="products" element={<PosLayout />} >
            <Route index element={<ProductsList />} />
            <Route path="stocks" element={<Stock />} />
            <Route path="stocktrans" element={<StockTrans />} />
            <Route path=":productid" element={<ProductDetail />} />
          </Route>

          <Route path="reports" element={<PosLayout />} >
            <Route index element={<Reports />} />
            <Route index element={<ScanPaid />} />
          </Route>
          <Route path="scanpaid" element={<PosLayout />} >
            <Route index element={<ScanPaid />} />
          </Route>
          <Route path="income" element={<PosLayout />} >
            <Route index element={<Income />} />
          </Route>


          <Route path="reservefunds" element={<PosLayout />} >
            <Route index element={<ReserveFunds />} />
          </Route>
 
        </Route>

        <Route path="/checkout" element={<CheckoutForm />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="addnew" element={<UpdateUser />} />
        <Route path="/test" element={<Test />} />

      </Routes>  
  );
}

export default App;
